import { gql } from '@apollo/client'

export const GET_NAUTICAL_WALLET_TRANSACTIONS = gql`
    query GetNauticalWalletTransactions($userEmail: EmailAddress!, $page: PageInput!) {
        getNauticalWalletTransactions(user_email: $userEmail, page: $page) {
            code
            success
            message
            tranx_count
            wallet {
                wallet_id
                user_email
                balance
                hold_balance
                last_updated
            }
            tranx {
                tranx_id
                tranx_date
                wallet_id
                tranx_type
                nautical_mile
                status
                reference_info
                description
            }
        }
    }
`